import type { TradeInStepName } from '@makemydeal/dr-activities-tradein';
import { Actions } from './actions';

export const tradeInStepChangeActionCreator = (step: TradeInStepName) => {
    return {
        type: Actions.TRADE_IN_STEP_CHANGED,
        payload: step
    };
};
